function onReadOnlyProduct() {
  return false;
}

function onSearchProduct(data) {
  return [
    ["active", "=", true],
    ["template.salable", "=", true],
    ["template.account_category", "!=", null],
    ["template.name", "ilike", `%${data}%`],
  ];
}

function onChangeProduct(storeId, record) {
  const product = record.active?.product;
  if (!product) return;

  const unit = product["sale_uom."];
  const template = product["template."];
  const listPrice = product.list_price.toFixed(2) || 0;

  record.active.quantity = record.active.quantity || 1;
  record.active.unit_price = listPrice;
  record.active.unit = unit;
  record.active.description = template?.name || product.name || "";

  record.store.unit_price = listPrice.toString();
  record.store.quantity = record.active.quantity || 1;
  record.store.unit = unit?.id;
  record.store.description = template?.name || product.name || "";
  record.store.product = product.id;
}

function layout() {
  const ctxView = {
    model: "crm.opportunity.line",
    form_action: ["add", "edit", "delete"],
    table_action: ["add", "edit"],
    target: "opportunity",
    fields: {
      product: {
        type: "many2one",
        model: "product.product",
        readOnly: onReadOnlyProduct,
        withChange: onChangeProduct,
        recSearch: onSearchProduct,
        required: true,
        attrs: [
          "id",
          "list_price",
          "name",
          "template.name",
          "sale_uom.rec_name",
        ],
      },
      unit: {
        type: "many2one",
        model: "product.uom",
        readOnly: true,
      },
      quantity: {
        type: "integer",
        required: true,
      },
      unit_price: {
        type: "numeric",
        required: true,
      },
      description: {
        type: "char",
        required: true,
      },
    },
    list: [
      { name: "product", width: "30%" },
      { name: "quantity", width: "30%" },
      { name: "unit", width: "30%" },
      { name: "unit_price", width: "30%" },
    ],
    form: [
      { name: "product" },
      { name: "description" },
      { name: "quantity" },
      { name: "unit" },
      { name: "unit_price" },
    ],
  };
  return ctxView;
}
export { layout };
